import DeliveryWindow from 'components/Checkout/Sections/SddSections/SddSection/DeliveryWindow/DeliveryWindow';
import withDeliveryWindowProps from 'viewModel/checkout/sections/sddSections/sddSection/deliveryWindow/withDeliveryWindowProps';

const ConnectedDeliveryWindow = withDeliveryWindowProps(DeliveryWindow);

export default ConnectedDeliveryWindow;
